<template>
  <div v-if="items.length" class="ps" :class="{ compact }">
    <p v-if="title" class="ps-title">{{ title }}</p>
    <div
      v-for="(p, i) in items"
      :key="p.id"
      class="ps-row"
      :class="{ active: i === activeIndex, due: p.kind === 'agenda_now' || p.kind === 'agenda_pending' }"
      @mouseenter="$emit('hover', i)"
    >
      <button type="button" class="ps-main" @click="open(p, 'record')">
        <span class="ps-name">{{ p.name }}</span>
        <small class="ps-reason">{{ p.reason }}</small>
      </button>
      <button v-if="canWriteNotes" type="button" class="ps-note" @click="open(p, 'note')">Anotar</button>
    </div>
  </div>
</template>

<script>
import { track } from "@/utils/analytics";

// The patients likely wanted right now (GET /dashboard/shortcuts, see PatientShortcuts):
// a click opens the record at the last note, "Anotar" opens a new note with the recorder.
export default {
  name: "ComponentPatientShortcuts",
  props: {
    title: { type: String, default: "" },
    where: { type: String, default: "" },
    compact: { type: Boolean, default: false },
    activeIndex: { type: Number, default: -1 },
    preload: { type: Array, default: null },
  },
  emits: ["loaded", "hover", "picked"],
  data() {
    return { items: this.preload || [] };
  },
  computed: {
    canWriteNotes() {
      const user = this.$store.getters["App/user"] || {};
      return user.account_type === "standard";
    },
  },
  mounted() {
    if (!this.preload) this.load();
  },
  methods: {
    async load() {
      try {
        const { data } = await this.$axios.get("/api/v1/dashboard/shortcuts");
        this.items = (data && data.shortcuts) || [];
      } catch (e) {
        this.items = [];
      }
      this.$emit("loaded", this.items);
    },
    open(p, action) {
      track("patient_shortcut", { where: this.where, action, kind: p.kind });
      const query = action === "note" ? { note: "1" } : { last: "1" };
      this.$router.push({ name: "CustomersDetails", params: { id: p.id }, query });
      this.$emit("picked", p);
    },
  },
};
</script>

<style scoped>
.ps-title {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: #7d8d92;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.ps-row {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  padding: 2px 4px 2px 0;
}
.ps-row + .ps-row {
  border-top: 1px solid #eef3f4;
}
.ps-row.active,
.ps-row:hover {
  background: #f2fafc;
}
.ps-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  padding: 8px 10px;
  border: 0;
  background: none;
  text-align: left;
  cursor: pointer;
}
.ps-name {
  font-weight: 600;
  color: #1f3b44;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.ps-reason {
  font-size: 12.5px;
  color: #7d8d92;
}
.ps-row.due .ps-reason {
  color: #a1531a;
}
.ps-note {
  flex-shrink: 0;
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid #29b1cc;
  background: #fff;
  color: #127a8f;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
}
.ps-note:hover {
  background: #29b1cc;
  color: #fff;
}
.compact .ps-main {
  padding: 6px 10px;
}
</style>
